module.exports = __webpack_public_path__ + "img/PestControlServices.085cd288.jpg";